<div class="group-details">
  <div class="content__header d-flex justify-content-between align-items-center">
    <h1 class="m--0"><strong>Subscription / Group Details</strong> (GID: {{ groupId }})</h1>
  </div>
  <div *ngIf="!loadingGroup && !loadingUsers && !loadingSubscription">
    <form [formGroup]="formStatus">   
      <div class="box__content box--padding-xxs h--200">
        <div class="row h--110">
          <div class="col-6">
            <div class="flex-column">
              <dl>
                <dt>Subscriber:</dt>
                <dd *ngIf="subscription">
                  <b>{{subscription.user?.displayName | isEmpty}}</b>
                  &nbsp;<span *ngIf="subscription.user?.email">( {{subscription.user?.email | isEmpty}} )</span>
                  &nbsp;<button mat-flat-button color="primary" style="padding: 0px 5px; height: 20px" class="btn sm btn-icon" (click)="onImpersonateByUid(subscription.user?.uid, groupId)" matTooltip="Impersonate user"><i class="far fa-eye"></i></button>
                </dd>
                <dt>Created On:</dt>
                  <dd><b>{{subscription?.created | date: 'mediumDate' | isEmpty}}</b></dd>
                <dt>Admin UID:</dt>
                  <dd>{{subscription?.user?.uid | isEmpty}} <i *ngIf="subscription?.user?.uid" class="fa fa-clipboard copy-clipboard" matTooltip="Copy to clipboard" matTooltipPosition="below" matTooltipClass="tooltip tooltip--black" [cdkCopyToClipboard]="subscription.user.uid"></i></dd>
                <dt><i class="fab fa-apple abc-apple-icon"></i> Apple Business:</dt>
                  <dd [ngSwitch]="abcState">
                    <span *ngSwitchCase="'LOADING'" class="abc-status abc-status--muted">Checking dark launch flags&hellip;</span>

                    <span *ngSwitchCase="'ENABLED_FOR_ALL'" class="abc-status abc-status--ok"
                          matTooltip="The appleBusinessConnect key in dark_launch_features is enabled for all users, so every user of this group has it."
                          matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                      <i class="fas fa-check-circle"></i> <b>Enabled for all users</b>
                    </span>

                    <ng-container *ngSwitchCase="'ENABLED_DARK_LAUNCH'">
                      <span class="abc-status abc-status--ok"
                            [matTooltip]="'dark_launch_users.appleBusinessConnect is true for the group admin uid ' + group?.admin"
                            matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                        <i class="fas fa-check-circle"></i> <b>Enabled</b> for the admin UID (dark launch)
                      </span>
                      <span *ngIf="abcUsersMissingCount" class="abc-status abc-status--warn">
                        <i class="fas fa-exclamation-triangle"></i>
                        {{ abcUsersMissingCount }} user(s) without the dark launch flag &mdash; see the Users tab
                      </span>
                    </ng-container>

                    <span *ngSwitchCase="'DISABLED'" class="abc-status abc-status--off"
                          [matTooltip]="'dark_launch_users.appleBusinessConnect is not set for the group admin uid ' + group?.admin"
                          matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                      <i class="fas fa-times-circle"></i> <b>Apple is not enabled</b> for this group
                    </span>

                    <span *ngSwitchDefault class="abc-status abc-status--muted"
                          matTooltip="The dark launch flags could not be read, this does not mean the feature is disabled."
                          matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                      <i class="fas fa-question-circle"></i> Unknown &mdash; could not read the dark launch flags
                    </span>
                  </dd>
                <dt><i class="fab fa-apple abc-apple-icon"></i> Apple connection:</dt>
                  <dd [ngSwitch]="appleConnectionState">
                    <span *ngSwitchCase="'LOADING'" class="abc-status abc-status--muted">
                      <i class="fas fa-question-circle"></i> Checking access in Apple&hellip;
                    </span>

                    <span *ngSwitchCase="'FAILED'" class="abc-status abc-status--warn"
                          matTooltip="core-api could not be reached, this does not mean MapLabs has lost access."
                          matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                      <i class="fas fa-exclamation-triangle"></i> Could not check the Apple connection
                    </span>

                    <ng-container *ngSwitchCase="'LOADED'">
                      <span *ngIf="!appleConnections.length" class="abc-status abc-status--muted">No Apple organization linked</span>

                      <div *ngFor="let c of appleConnections" class="apple-connection">
                        <ng-container [ngSwitch]="c.access">
                          <span *ngSwitchCase="'connected'" class="abc-status abc-status--ok"
                                matTooltip="Apple returns brands or locations for this organization."
                                matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                            <i class="fas fa-check-circle"></i> <b>Connected</b>
                          </span>
                          <span *ngSwitchCase="'no_access'" class="abc-status abc-status--error"
                                matTooltip="MapLabs no longer has access to this organization in Apple Business Connect. The customer needs to re-share access with MapLabs."
                                matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                            <i class="fas fa-times-circle"></i> <b>No access</b><span *ngIf="c.appleCode"> ({{ c.appleCode }})</span>
                          </span>
                          <span *ngSwitchDefault class="abc-status abc-status--warn"
                                [matTooltip]="c.error || 'The access check failed'"
                                matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                            <i class="fas fa-exclamation-triangle"></i> <b>Check failed</b>
                          </span>
                        </ng-container>
                        {{ c.companyId }}<button type="button" class="apple-connection__copy" [attr.aria-label]="'Copy Apple organization ID ' + c.companyId"
                                matTooltip="Copy to clipboard" matTooltipPosition="below" matTooltipClass="tooltip tooltip--black"
                                [cdkCopyToClipboard]="c.companyId"><i class="fa fa-clipboard copy-clipboard" aria-hidden="true"></i></button>
                        <span class="apple-connection__meta">
                          <span *ngIf="c.createdAt">linked {{ c.createdAt | date: 'mediumDate' }} &middot; </span>checked {{ c.checkedAt | date: 'short' }}
                        </span>
                      </div>
                    </ng-container>
                  </dd>
                <dt>Group GID:</dt>
                  <dd>{{groupId}}<i class="fa fa-clipboard copy-clipboard" matTooltip="Copy to clipboard" matTooltipPosition="below" matTooltipClass="tooltip tooltip--black" [cdkCopyToClipboard]="groupId"></i></dd>
                <dt>Pricing Version:</dt>
                  <dd><b>{{ subscription?.pricingVersion }}</b>
                    <span *ngIf="subscription?.billingOverride">&nbsp;&nbsp;<i>with Billing Override</i></span>
                    <span *ngIf="packageStatus('pkg_bulk_actions') === 'ACTIVE'">&nbsp;&nbsp;<i>with Bulk Actions</i></span>
                  </dd>
                <dt>Users:</dt>
                  <dd>{{ dataSource?.length || 0 }}</dd>
                <dt>Location counts:</dt>
                  <dd>{{ group?.ultimateLocationsCount || 0 }} ULTIMATE
                    <span *ngIf="group?.basicLocationsCount">&mdash; {{ group?.basicLocationsCount || 0 }} BASIC</span> 
                    <span *ngIf="group?.freeLocationsCount">&mdash; {{ group?.freeLocationsCount || 0 }} FREE</span>
                  </dd>
              </dl>
            </div>
          </div>

          <div class="col-6">
            <div class="flex-column">
              <ul>
                <li>
                  <mat-form-field appearance="fill">
                    <mat-label>Company Name</mat-label>
                    <input matNativeControl type="text" formControlName="company" />
                  </mat-form-field>&nbsp;
                  <button mat-button color="primary" mat-flat-button (click)="onSaveGroupDetails()" style="margin-left: 2em;">Save Company Name</button>
                </li>
                <li>
                  <mat-form-field appearance="fill">
                    <mat-label>Subscription Status</mat-label>
                    <mat-select [value]="subscription?.status" (selectionChange)="handleChangeSubscriptionStatus($event.value)">
                        <mat-option value="TRIAL">Trial</mat-option>
                        <mat-option *ngIf="subscription?.status === 'PAID'"   value="PAID">Active - Paid</mat-option>
                        <mat-option *ngIf="subscription?.status === 'UNPAID'" value="UNPAID">Active - Unpaid</mat-option>
                        <mat-option *ngIf="subscription?.status !== 'PAID' && subscription?.status !== 'UNPAID'" value="ACTIVE">Active</mat-option>
                        <mat-option value="BLOCKED">Blocked</mat-option>
                    </mat-select>
                  </mat-form-field>
                  &nbsp; &nbsp;
                  <mat-form-field appearance="fill" *ngIf="subscription?.status === 'TRIAL'">
                    <mat-label>Trial End Date</mat-label>
                    <input matInput 
                           readonly 
                           [min]="trialEndMin"
                           [matDatepicker]="picker" 
                           [formControl]="formTrialEnd" 
                           (dateChange)="handleTrialEndChanged($event.target.value)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> <!-- matIconSuffix -->
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <span *ngIf="subscription?.status === 'BLOCKED' && subscription.statusReason"> 
                    Block Reason: 
                    {{ {'TRIAL_EXPIRED'   : "Blocked by Trial expiration", 
                        'UNPAID_TOO_LONG' : "Blocked by overdue payments", 
                        'MANUAL_BLOCK'    : "Manually Blocked",
                        'CANCELED'        : "Canceled"}[subscription?.statusReason]
                    }}
                  </span>
                </li>
                <li>
                  <button *ngIf="subscription && !subscription.isCancellationScheduled"
                          mat-button color="warn" mat-flat-button
                          (click)="handleSubscriptionCancelClick()">Cancel Subscription</button>
                  <span *ngIf="subscription?.isCancellationScheduled"><b>Cancellation Scheduled</b></span>
                </li>
                <li *ngIf="subscription?.discount">Discount: {{subscription?.discount}} %</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="content__body box box--rounded box--shadow bg--white">

    <mat-tab-group #tabGroup [selectedIndex]="activeTab">

      <!-----------------------------------------------------------------------
      | Users
      `----------------------------------------------------------------------->
      
      <mat-tab label="Users">
        <app-skeletons [visibleSection]="'groups-users-details'" *ngIf="loadingUsers"></app-skeletons>

        <p-table *ngIf="!loadingUsers" #userDT [value]="dataSource" [columns]="USER_COLS" styleClass="p-datatable" [rowHover]="true"
        [responsive]="true"
        [paginator]="true" [rows]="100" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50,100]"
        currentPageReportTemplate="{{userDT.filteredValue?.length || dataSource?.length}} entries" (onPage)="pageChange($event)"
        [filterDelay]="0" [globalFilterFields]="['email', 'displayName', 'role', 'createdOn', 'signedOn']">
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="input-field--search filter-table">
                <section class="table-actions">
                  <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Clear filter and sort" matTooltipPosition="below" matTooltipClass="tooltip tooltip--black" (click)="clearTable(userDT)">
                    <i class="pi pi-filter-slash"></i>
                  </button>
                  <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Export CSV" matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="userDT.exportCSV()">
                    <i class="pi pi-file"></i>
                  </button>
                  <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Export PDF" matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="exportPdf('users', USER_COLS, userDT)">
                    <i class="pi pi-file-pdf"></i>
                  </button>
                </section>
                <section class="table-filter">
                  <div class="table__icon table__icon--lg">
                    <i class="fas fa-search"></i>
                  </div>
                </section>
                <input pInputText type="text" [ngModel]="filterField" (input)="userDT.filterGlobal($event.target.value, 'contains')" placeholder="Type to search" />
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <ng-container *ngFor="let col of USER_COLS">
                <th pSortableColumn="{{col.field}}" [class.is-currency]="false">
                  <div class="p-d-flex p-jc-between p-ai-center">
                    {{col.header | titlecase}}
                    <p-sortIcon field="{{col.field}}"></p-sortIcon>
                    <p-columnFilter *ngIf="col.field !== 'createdOn' && col.field !== 'signedOn'" type="text" field="{{col.field}}" display="menu"></p-columnFilter>
                    <p-columnFilter *ngIf="col.field === 'createdOn' || col.field === 'signedOn'" type="date" field="{{col.field}}" display="menu"></p-columnFilter>
                  </div>
                </th>
              </ng-container>
              <th>
                <div class="txt--right">Actions</div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-dataSource>
            <tr class="p-selectable-row" [class.abc-row--warn]="abcUserState[dataSource?.uid] === 'MISSING'">
              <td class="td-width-m align-left-table">
                {{dataSource?.email | isEmpty}}
                <div *ngIf="abcUserState[dataSource?.uid] === 'MISSING'" class="abc-status abc-status--row abc-status--warn"
                     matTooltip="The group admin has the appleBusinessConnect dark launch flag but this user does not, so this user will not see the Apple features."
                     matTooltipPosition="below" matTooltipClass="tooltip tooltip--black">
                  <i class="fas fa-exclamation-triangle"></i> <i class="fab fa-apple abc-apple-icon"></i> Apple dark launch flag not set
                </div>
                <div *ngIf="abcUserState[dataSource?.uid] === 'UNKNOWN'" class="abc-status abc-status--row abc-status--muted">
                  <i class="fas fa-question-circle"></i> <i class="fab fa-apple abc-apple-icon"></i> Could not read the Apple Business dark launch flag
                </div>
              </td>
              <td class="td-width-m"> {{dataSource?.displayName | titlecase | isEmpty}}</td>
              <td>{{dataSource?.role | titlecase | isEmpty}}</td>
              <td>{{dataSource?.createdOn | date: 'mediumDate' | isEmpty}}</td>
              <td>{{dataSource?.signedOn  | date: 'mediumDate' | isEmpty}}</td>
              <td class="align-right-table">
                <button *ngIf="subscription" mat-flat-button color="primary" class="btn btn-icon mr--5"
                    (click)="onImpersonate(dataSource)" matTooltip="Impersonate">
                  <i class="far fa-eye"></i>
                </button>
                <button mat-flat-button color="primary" class="btn btn-icon mr--5"
                    (click)="resetPassword(dataSource)" matTooltip="Reset password">
                  <i class="far fa-lock-alt"></i>
                </button>
                <button mat-flat-button color="primary" class="btn btn-icon mr--5"
                    (click)="updateRole(dataSource)" matTooltip="To {{role(dataSource)}}">
                  <i class="far fa-power-off"></i>
                </button>
                <button *ngIf="isSuperAdmin && subscription" mat-flat-button color="accent" class="btn btn-icon mr--5"
                    (click)="onImpersonate(dataSource, true)" matTooltip="Impersonate on staging">
                  <i class="far fa-eye"></i>
                </button>
                <button mat-flat-button color="warn" class="btn btn-icon"
                    (click)="deleteUser(dataSource)" matTooltip="Delete">
                  <i class="far fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No users found.</td>
            </tr>
          </ng-template>
        </p-table>
      </mat-tab>


      <!-----------------------------------------------------------------------
      | Subscription Details
      `----------------------------------------------------------------------->

      <mat-tab label="Pricing">
        <app-skeletons [visibleSection]="'groups-subs-details'" *ngIf="loadingSubscription"></app-skeletons>

        <section *ngIf="!loadingSubscription">
          <div>
          <div>
            <p-table 
              #subsDT 
              [value]="dataSourceSubs" 
              [loading]="loadingSubscriptionTable" 
              [columns]="SUBSCRIPTIONS_COLS" 
              styleClass="p-datatable" 
              [rowHover]="true"
              [responsive]="true"
              [paginator]="true" 
              [rows]="100" 
              [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10,25,50,100]" 
              currentPageReportTemplate="{{subsDT.filteredValue?.length || dataSourceSubs?.length}} entries"
              [filterDelay]="0" 
              [globalFilterFields]="['locationName', 'locationAddress', 'pid', 'price', 'net', 'created']">
                <ng-template pTemplate="caption">
                  <div class="table-header">
                    <div class="input-field--search filter-table">
                      <section class="table-actions">
                        <button *ngIf="isSuperAdmin" mat-flat-button color="primary" class="btn btn-icon" matTooltip="Add Product"
                          matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="openAddProductModal('add')">
                          <i class="pi pi-plus"></i>
                        </button>
                        <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Clear filter and sort"
                          matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="clearTable(subsDT)">
                          <i class="pi pi-filter-slash"></i>
                        </button>
                        <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Export CSV" matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="subsDT.exportCSV()">
                          <i class="pi pi-file"></i>
                        </button>
                        <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Export PDF" matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="exportPdf('subscription', SUBSCRIPTIONS_COLS, subsDT)">
                          <i class="pi pi-file-pdf"></i>
                        </button>
                      </section>
                      <section class="table-filter">
                        <div class="table__icon table__icon--lg">
                          <i class="fas fa-search"></i>
                        </div>
                      </section>
                      <input pInputText type="text" [ngModel]="filterField"
                        (input)="subsDT.filterGlobal($event.target.value, 'contains')" placeholder="Type to search" />
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <ng-container *ngFor="let col of SUBSCRIPTIONS_COLS">
                      <th pSortableColumn="{{col.field}}" [class.is-currency]="col.isCurrency">
                        <div class="p-d-flex p-jc-between p-ai-center" [class.txt--right]="col?.field === 'price'">
                          {{col.header | titlecase}}
                          <p-sortIcon field="{{col.field}}"></p-sortIcon>
                          <p-columnFilter *ngIf="col.field === 'locationName' || col.field === 'locationAddress'" type="text" field="{{col.field}}" display="menu"></p-columnFilter>
                          <p-columnFilter *ngIf="col.field === 'created'" type="date" field="{{col.field}}" display="menu"></p-columnFilter>
                          <p-columnFilter *ngIf="col.field === 'price' || col.field === 'net'" type="numeric" field="{{col.field}}" display="menu"></p-columnFilter>
                          <p-columnFilter #cf *ngIf="col.field === 'pid'" field="{{col.field}}" matchMode="in" display="menu">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown [ngModel]="value" [options]="productSubsOptions" placeholder="Products" (onChange)="filter($event.value); cf.hide()">
                                </p-dropdown>
                            </ng-template>
                          </p-columnFilter>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-sub>
                  <tr class="p-selectable-row">
                    <td class="td-width-m"><span [outerHTML]="sub?.locationName | isEmpty"></span></td>
                    <td class="td-width-m"><span [outerHTML]="sub?.locationAddress | isEmpty"></span></td>
                    <td><span [outerHTML]="sub?.pid | titlecase | isEmpty"></span></td>
                    <td class="align-right-table"><span [outerHTML]="sub?.price | currency | isEmpty"></span></td>
                    <td class="align-right-table"><span [outerHTML]="sub?.net | currency | isEmpty"></span></td>
                    <td>{{sub?.created | date: 'mediumDate' | isEmpty}}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="8">No data found.</td>
                  </tr>
                </ng-template>
              </p-table>
          </div>
          </div>
        </section>
      </mat-tab>


      <!-----------------------------------------------------------------------
      | Billing
      `----------------------------------------------------------------------->

      <mat-tab label="Billing">
        <app-skeletons [visibleSection]="'groups-billing'" *ngIf="loadingGroup || loadingUsers || loadingSubscription"></app-skeletons>

        <section *ngIf="!loadingGroup && !loadingUsers && !loadingSubscription">
          <div>

            <!-- Billing Type -->
            <div *ngIf="group?.isDomainOwner" class="box__header">
              <h2 class="txt--black m--0 billing-text-desc">
                  <span *ngIf="group?.isDomainOwner && subscription.generatesOwnerInvoices">
                    Owner of White Label {{group.domain}}
                  </span>
                  <span *ngIf="group?.isDomainOwner && !subscription.generatesOwnerInvoices">
                    Owner of White Label {{group.domain}} (also End Customer)
                  </span>
                  <!-- <span *ngIf="!group?.isDomainOwner">
                    End Customer
                  </span>  -->
                </h2>
              </div>
  
            <div class="box__header">
              <h2 class="txt--capitalize txt--black m--0">
                <strong>Credit Cards</strong>
              </h2>
            </div>

            <!-- Credit Cards -->
            <!-- TODO: Refactorize against settings.component.html -->
            <div class="box__content box--padding-xxs">

              <div class="box__content" *ngIf="!loadingCards">
                <div *ngIf="!cards.length" class="billing-text-desc">
                  <!-- Credit Card Required -->
                  No Credit Cards set up
                  <span *ngIf="subscription && !requiresPaymentMethod()">
                    - not required
                  </span>
                  <span *ngIf="subscription && requiresPaymentMethod()" class="billing-text-warn">
                    - <b>REQUIRED <i class="fa fa-triangle-exclamation"></i></b>
                  </span>

                </div>
                <div *ngIf="cards.length">
                 <div *ngFor="let card of cards; let i = index">
                  <div class="box__item pt--0 mb--20 border-bottom">
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="d-flex align-items-center">
                          <div class="credit-card">                          
                            <img src="{{getCardBrandImage(card.brand)}}" alt="{{card.brand}} Logo"/>
                          </div>
                          <div>
                            <p class="mb--5">Credit Card</p>
                            <p class="m--0 txt--black"><strong>**** {{ card?.last4 }}</strong></p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <p class="mb--5">Expiration Date</p>
                        <p class="m--0 txt--black"><strong>{{ card?.exp_month }}/{{ card?.exp_year }}</strong></p>
                      </div>
                      <div *ngIf="i === 0" class="col-3 review-response review-response--xs review-response--info">
                        <p class="m--5 txt--center txt--blue txt--uppercase" on>
                          <strong>Default</strong>
                        </p>
                      </div>
                      <!--
                      <div *ngIf="i !== 0" class="col-3 review-response review-response--xs review-response--error cursor--pointer">
                        <p class="m--5 txt--center txt--orange txt--uppercase" (click)="handleDefaultSource({card: card})">
                          <strong>Set as default</strong>
                        </p>
                      </div>
                      <div *ngIf="i !== 0" class="col-2">
                        <button (click)="handleDeleteSource({card: card})" mat-flat-button color="warn" class="btn btn-icon">
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </div>
                      -->
                    </div>
                  </div>
                   </div>
                </div>
              </div>
  
  
            </div>
  
            <div class="box__header">
              <h2 class="txt--black m--0">
                <strong>Billing</strong>
              </h2>
            </div>

            <form [formGroup]="formStripe">
              <div class="box__content box--padding-xxs h--200">
                <div class="row mb--20 h--50">

                  <div class="col-6">
                    <!-- Stripe Customer ID Editable field -->
                    <div *ngIf="stripeCustomerDisplayMode === 'FIELD_EDITABLE'"
                         class="flex-column" >
                      <mat-label class="mb--5">
                        Stripe Customer ID
                        <i class="fa fa-clipboard copy-clipboard" 
                           matTooltip="Copy to clipboard" 
                           matTooltipPosition="below"
                           matTooltipClass="tooltip tooltip--black" 
                           [cdkCopyToClipboard]="formStripe.controls.customerId.value">
                        </i>

                        <!-- Stripe Customer Dashboard Link -->
                        <a *ngIf="stripeCustomerDashboardURL"
                           [href]="stripeCustomerDashboardURL" target="_blank">
                          &nbsp;
                          <i class="fa fa-external-link" 
                             matTooltip="Open Customer on Stripe Dashboard" 
                             matTooltipPosition="below"
                             matTooltipClass="tooltip tooltip--black">
                          </i>
                        </a>    
                      </mat-label>

                       <!-- Stripe Customer Dashboard Input -->
                      <input type="text" 
                             formControlName="customerId"
                             class="input-group__field input-group__field--sm"
                             [readOnly]="!billingIsEditable"
                             />
                    </div>

                    <!-- Stripe Customer Link Only -->
                    <div *ngIf="stripeCustomerDisplayMode === 'LINK_ONLY' && stripeCustomerDashboardURL"
                         class="flex-column" >
                      <a [href]="stripeCustomerDashboardURL" target="_blank">
                         Stripe Customer&nbsp;
                       <i class="fa fa-external-link" 
                          matTooltip="Open Customer on Stripe Dashboard" 
                          matTooltipPosition="below"
                          matTooltipClass="tooltip tooltip--black">
                       </i>
                      </a> 
                    </div>

                  </div>

                  <!-- Billing Override field -->
                  <div class="col-6">
                    <div class="flex-column billing-checkbox">
                      <mat-checkbox *ngIf="billingOverrideField_mustBeShown()"
                                    formControlName="billingOverride" 
                                    class="billing-checkbox"
                                    [disabled]="!billingIsEditable"
                                    >
                          Billing Override
                      </mat-checkbox>
                      <div class="box--padding-xxs mat-caption mat-text-disabled billing-text-desc">
                        {{subscription ? collectionTargetDesc() : ''}}
                      </div> 
                    </div>
                   </div>

                </div>

                <!-- Save button -->
                <div class="txt--right">
                  <button color="primary" mat-flat-button class="btn btn--lg" (click)="onSaveBilling()">
                    Save
                  </button>
                </div>

              </div>
            </form>

            <ng-container *ngIf="subscription?.pricingVersion >= 3">
              <div class="box__header">
                <h2 class="txt--black m--0">
                  <strong>Packages</strong>
                </h2>
              </div>

              <div class="box__content box--padding-xxs">
                <div class="row mb--20">

                  <!-- Bulk Updates -->
                  <div class="col-12">
                    <div>
                      <strong>Bulk Updates</strong>
                      <span class="mat-caption ml--10" *ngIf="packageStatus('pkg_bulk_actions') === 'ACTIVE'">Active</span>
                      <span class="mat-caption ml--10" *ngIf="packageStatus('pkg_bulk_actions') === 'NONE'">Not enabled</span>
                      <span class="mat-caption ml--10" *ngIf="packageStatus('pkg_bulk_actions') === 'SCHEDULED_TERMINATION'">
                        Scheduled to end in next billing cycle
                      </span>
                    </div>

                    <div class="mt--10">
                      <button mat-stroked-button *ngIf="packageStatus('pkg_bulk_actions') === 'NONE'"
                              (click)="addPackage('pkg_bulk_actions')">
                        Enable
                      </button>

                      <ng-container *ngIf="packageStatus('pkg_bulk_actions') === 'ACTIVE' || packageStatus('pkg_bulk_actions') === 'SCHEDULED_TERMINATION'">
                        <button mat-stroked-button *ngIf="packageStatus('pkg_bulk_actions') === 'ACTIVE'"
                                (click)="scheduleTermination('pkg_bulk_actions')">
                          Schedule Termination
                        </button>
                        <button mat-stroked-button *ngIf="packageStatus('pkg_bulk_actions') === 'SCHEDULED_TERMINATION'"
                                (click)="cancelScheduledTermination('pkg_bulk_actions')">
                          Cancel Scheduled Termination
                        </button>
                        <button mat-stroked-button color="warn" class="ml--10"
                                (click)="terminatePackageNow('pkg_bulk_actions', 'Bulk Updates')">
                          Terminate Immediately
                        </button>
                      </ng-container>
                    </div>
                  </div>

                  <!-- Coaching -->
                  <div class="col-12 mt--20">
                    <div>
                      <strong>Coaching</strong>
                      <span class="mat-caption ml--10" *ngIf="packageStatus('pkg_coaching') === 'ACTIVE'">Active</span>
                      <span class="mat-caption ml--10" *ngIf="packageStatus('pkg_coaching') === 'NONE'">Not enabled</span>
                      <span class="mat-caption ml--10" *ngIf="packageStatus('pkg_coaching') === 'SCHEDULED_TERMINATION'">
                        Scheduled to end in next billing cycle
                      </span>
                    </div>

                    <div class="mt--10">
                      <button mat-stroked-button *ngIf="packageStatus('pkg_coaching') === 'NONE'"
                              [disabled]="formPackages.invalid"
                              (click)="addPackage('pkg_coaching')">
                        Enable
                      </button>

                      <ng-container *ngIf="packageStatus('pkg_coaching') === 'ACTIVE' || packageStatus('pkg_coaching') === 'SCHEDULED_TERMINATION'">
                        <button mat-stroked-button *ngIf="packageStatus('pkg_coaching') === 'ACTIVE'"
                                (click)="scheduleTermination('pkg_coaching')">
                          Schedule Termination
                        </button>
                        <button mat-stroked-button *ngIf="packageStatus('pkg_coaching') === 'SCHEDULED_TERMINATION'"
                                (click)="cancelScheduledTermination('pkg_coaching')">
                          Cancel Scheduled Termination
                        </button>
                        <button mat-stroked-button color="warn" class="ml--10"
                                (click)="terminatePackageNow('pkg_coaching', 'Coaching')">
                          Terminate Immediately
                        </button>
                      </ng-container>
                    </div>

                    <form [formGroup]="formPackages" class="mt--10">
                      <mat-form-field appearance="fill" class="coaching-price-field">
                        <mat-label>Coaching Monthly Price</mat-label>
                        <input matInput type="text" formControlName="coachingPrice">
                        <mat-error *ngIf="formPackages.controls.coachingPrice.hasError('required')">
                          Price is required to enable Coaching
                        </mat-error>
                      </mat-form-field>

                      <button mat-stroked-button class="ml--10"
                              *ngIf="packageStatus('pkg_coaching') !== 'NONE'"
                              [disabled]="formPackages.invalid"
                              (click)="updateCoachingPrice()">
                        Update Price
                      </button>
                    </form>
                  </div>

                </div>
              </div>
            </ng-container>

          </div>
        </section>
      </mat-tab>


      <!-----------------------------------------------------------------------
      | Invoices
      `----------------------------------------------------------------------->

      <mat-tab label="Invoices">
        <app-skeletons [visibleSection]="'groups-invoice-details'" *ngIf="loadingInvoices">          
        </app-skeletons>

        <p-table *ngIf="!loadingInvoices" 
        #invoicesDT 
        [value]="dataSourceInvoices" 
        [columns]="INVOICES_COLS" 
        styleClass="p-datatable" 
        [rowHover]="true"
        [responsive]="true"
        [paginator]="true" 
        [rows]="100" 
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,25,50,100]" 
        currentPageReportTemplate="{{invoicesDT.filteredValue?.length || dataSourceInvoices?.length}} entries"
        [filterDelay]="0" 
        [globalFilterFields]="['name', 'status', 'invoiceTotal', 'invoiceFeeTotal', 'invoiceDiscountTotal', 
                               'created', 'updated', 'registrationDomain', 'gid', 'id']">
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="input-field--search filter-table">
                <section class="table-actions">
                  <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Clear filter and sort"
                    matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="clearTable(invoicesDT)">
                    <i class="pi pi-filter-slash"></i>
                  </button>
                  <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Export CSV" matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="invoicesDT.exportCSV()">
                    <i class="pi pi-file"></i>
                  </button>
                  <button mat-flat-button color="primary" class="btn btn-icon" matTooltip="Export PDF" matTooltipPosition="below" matTooltipClass="tooltip tooltip--white" (click)="exportPdf('invoices', INVOICES_COLS, invoicesDT)">
                    <i class="pi pi-file-pdf"></i>
                  </button>
                </section>
                <section class="table-filter">
                  <div class="table__icon table__icon--lg">
                    <i class="fas fa-search"></i>
                  </div>
                </section>
                <input pInputText type="text" [ngModel]="filterField"
                  (input)="invoicesDT.filterGlobal($event.target.value, 'contains')" placeholder="Type to search" />
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <ng-container *ngFor="let col of INVOICES_COLS">
                <th pSortableColumn="{{col?.field}}" [class.is-currency]="col.isCurrency">
                  <div class="p-d-flex p-jc-between p-ai-center">
                    {{col.header | titlecase}}
                    <p-sortIcon field="{{col.field}}"></p-sortIcon>
                    <p-columnFilter *ngIf="col.field === 'name'" type="text" field="{{col.field}}" display="menu"></p-columnFilter>
                    <p-columnFilter *ngIf="col.field === 'invoiceTotal' || col.field === 'totalPlataformFee' || col.field === 'invoiceDiscountTotal'" type="numeric" field="{{col.field}}" display="menu" currency="USD"></p-columnFilter>
                    <p-columnFilter *ngIf="col.field === 'created' || col.field === 'updated'" type="date" field="{{col.field}}" display="menu"></p-columnFilter>
                    <p-columnFilter #cf *ngIf="col.field === 'status'" field="{{col.field}}" matchMode="in" display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown [ngModel]="value" [options]="statusOptions" placeholder="Status" (onChange)="filter($event.value); cf.hide()">
                        </p-dropdown>
                    </ng-template>
                    </p-columnFilter>
                  </div>
                </th>
              </ng-container>
            </tr>
          </ng-template>
          
          <ng-template pTemplate="body" let-inv>
            <tr class="p-selectable-row">
              <td (click)="selectInvoices(inv)" class="td-width-xl align-left-table">
                {{ inv.user.displayName | titlecase }} - {{ inv.user.email }}
              </td>
              <td (click)="selectInvoices(inv)">
                <span [outerHTML]="(inv.isDraft ? 'Next (Draft)' : inv.status) | titlecase | isEmpty"></span>
                <span *ngIf="inv.retry >= 1" matTooltip="Number of retries: {{inv.retry}}" matTooltipClass="tooltip tooltip--black"> 
                  ({{inv.retry}}) 
                  <span class="txt--red">*</span>
                </span>
              </td>
              <td (click)="selectInvoices(inv)" class="align-right-table" 
                  matTooltip="{{invoiceService.getTooltip(inv)}}" 
                  matTooltipClass="tooltip tooltip--black">
                <span [outerHTML]="inv.invoiceTotal | isEmpty"></span>
              </td>
              <td (click)="selectInvoices(inv)" class="align-right-table">
                <span [outerHTML]="inv.invoiceDiscountTotal | isEmpty">                  
                </span>
              </td>
              <td (click)="selectInvoices(inv)" class="align-right-table">
                <span [outerHTML]="inv.invoiceFeeTotal | isEmpty">                 
                </span>
              </td>
              <td (click)="selectInvoices(inv)">
                <span>{{(inv.isDraft ? inv.date : inv.created)  | date: 'mediumDate' | isEmpty}}</span>
              </td>
              <td (click)="selectInvoices(inv)">
                <span *ngIf="inv.isDraft">---</span>
                <span *ngIf="!inv.isDraft" [outerHTML]="inv.updated  | date: 'mediumDate' | isEmpty"></span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No invoices found.</td>
            </tr>
          </ng-template>
        </p-table>

      </mat-tab>

    </mat-tab-group>
  </div>
</div>
